module.exports = __webpack_public_path__ + "img/10.746a7da2.jpg";